<template>
  <section class="main layout">

    <layout-header/>

    <layout-content/>

    <layout-footer/>

  </section>

</template>

<script>
  import LayoutHeader  from './Header'
  import LayoutContent from './Content'
  import LayoutFooter  from './Footer'

  export default {
    name: 'Layout',

    components: { LayoutHeader, LayoutContent, LayoutFooter }
  }
</script>
